import React, { Component } from 'react';
import { tipoUnidad } from '../libs/utils/Const';

const renderTableBody = (headers, data, checkbox, openDetails) => {
    let body = "";
    body = data.map((register, index) => {
        if (register.statusBorrador !== 'W' && register.statusBorrador !== 'Y') {
            return (
                <tr key={index}>
                    {headers[0].value && <td className="dataTables-body-center">{register.Codigo}</td>}
                    {headers[1].value && <td className="dataTables-body-center">{register.CodigoUnidad || ''}</td>}
                    {headers[2].value && <td className="dataTables-body-center">{register?.nombre || '-'}</td>}
                    {headers[3].value && <td className="dataTables-body-center">{tipoUnidad.find(uni => uni.value === register.TipoUnidad)?.label ?? '-'}</td>}
                    {headers[4].value && <td className="dataTables-body-center">{register?.PlacaVM ?? ''}</td>}
                    {headers[5].value && <td className="dataTables-body-center">{register.AnioModeloVM}</td>}
                    {headers[6].value && <td className="dataTables-body-center">{register.PermSCT}</td>}
                    {headers[7].value && <td className="dataTables-body-center">{register.NumPermisoSCT}</td>}
                    <td className="sticky-columns dataTables-body-center" style={{ backgroundColor: "#e9ecef" }}>
                        <button type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                            onClick={() => openDetails({ tipoTransporte: register.TipoTransporte, Code: register.Codigo, index })}
                            style={{ fontWeight: '500' }}>
                            <i className="far fa-file-alt">
                            </i> Ver Detalles
                        </button>
                    </td>
                </tr>
            )
        }
    })
    return body;
};

const renderTable = (headers, data, checkbox, openDetails) => {
    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header = <tr>
            {headers[0].value && <td className="dataTables-header-center">{headers[0].title}</td>}
            {headers[1].value && <td className="dataTables-header-center">{headers[1].title}</td>}
            {headers[2].value && <td className="dataTables-header-center">{headers[2].title}</td>}
            {headers[3].value && <td className="dataTables-header-center">{headers[3].title}</td>}
            {headers[4].value && <td className="dataTables-header-center">{headers[4].title}</td>}
            {headers[5].value && <td className="dataTables-header-center">{headers[5].title}</td>}
            {headers[6].value && <td className="dataTables-header-center">{headers[6].title}</td>}
            {headers[7].value && <td className="dataTables-header-center">{headers[7].title}</td>}
            <td className="sticky-columns dataTables-header-center" style={{ backgroundColor: "#e9ecef" }}>Acciones</td>
        </tr>;
    }

    body = renderTableBody(headers, data, checkbox, openDetails);

    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
        <thead className="table-header">
            {header}
        </thead>
        <tbody>
            {body}
        </tbody>
    </table>;

    return table;

};

export const renderTransporte = (headers, data, checkbox, openDetails) => {

    return renderTable(headers, data, checkbox, openDetails);

}